import { render, staticRenderFns } from "./score-card.vue?vue&type=template&id=31417418&scoped=true"
import script from "./score-card.vue?vue&type=script&lang=js"
export * from "./score-card.vue?vue&type=script&lang=js"
import style0 from "./score-card.vue?vue&type=style&index=0&id=31417418&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31417418",
  null
  
)

export default component.exports